(() => {
  document.documentElement.dataset.ifTextilePriceVersion = '20261027-3';
  const options = new Map([
    ['sem estampagem', 'none'],
    ['frente', 'front'],
    ['verso', 'back'],
    ['mangas', 'sleeves'],
    ['frente e verso', 'front-back'],
    ['frente e mangas', 'front-sleeves'],
    ['verso e mangas', 'back-sleeves'],
    ['todos os lados', 'all'],
  ]);

  const prices = new Map([
    ['sem estampagem', '5,90 €'],
    ['frente', '8,00 €'],
    ['verso', '8,00 €'],
    ['mangas', '7,00 €'],
    ['frente e verso', '9,00 €'],
    ['frente e mangas', '9,00 €'],
    ['verso e mangas', '9,00 €'],
    ['todos os lados', '10,00 €'],
  ]);

  const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-PT');

  const formatMoney = (cents, currency = 'EUR') => {
    const locale = document.documentElement.lang || 'pt-PT';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  };

  const updateAddonPriceDisplays = () => {
    document.querySelectorAll('[data-if-addon-print-selector]').forEach((selector) => {
      const selected = selector.querySelector('[data-if-addon-print]:checked');
      if (!(selected instanceof HTMLInputElement)) return;

      const basePrice = Number.parseInt(selector.dataset.ifAddonBasePrice || '0', 10) || 0;
      const surcharge = Number.parseInt(selected.dataset.addonSurcharge || '0', 10) || 0;
      const total = basePrice + surcharge;
      if (total <= 0) return;
      selector.dataset.ifAddonTotal = String(total);

      const formatted = formatMoney(total, selector.dataset.ifAddonCurrency || 'EUR');
      const section = selector.closest('.shopify-section') || document;
      const priceContainers = new Set([
        ...section.querySelectorAll('product-price [ref="priceContainer"]'),
        ...document.querySelectorAll('.sticky-add-to-cart__price [ref="priceContainer"]'),
      ]);

      priceContainers.forEach((container) => {
        const price = container.querySelector('.price:not(.compare-at-price) bdi, .price bdi');
        if (!price) return;

        const current = price.textContent.trim();
        const amount = (total / 100).toLocaleString(document.documentElement.lang || 'pt-PT', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const displayPrice = current.startsWith('€') ? '€' + amount : formatted;
        if (current !== displayPrice) {
          price.textContent = displayPrice;
        }
      });
    });
  };

  const printOptionNames = new Set(['estampagem', 'local da personalização', 'local de estampagem']);
  const isPrintOptionName = (value) => printOptionNames.has(normalize(value));

  const colorOptionNames = new Set(['cor', 'color', 'colour']);
  const isColorOptionName = (value) => colorOptionNames.has(normalize(value));

  const colors = new Map([
    ['preto', '#151515'],
    ['branco', '#ffffff'],
    ['branco matizado', '#f2f0eb'],
    ['cinza claro', '#c7c9cc'],
    ['cinza frio', '#a7adb5'],
    ['cinzento', '#80858a'],
    ['cinza matizado', '#96999d'],
    ['amarelo', '#f4c430'],
    ['amarelo digital', '#ffd400'],
    ['amarelo pastel', '#f5e481'],
    ['amarelo fluo', '#dfff00'],
    ['laranja', '#f28c28'],
    ['laranja fluo', '#ff6a00'],
    ['alperce', '#f2a66f'],
    ['coral', '#ef7167'],
    ['vermelho', '#c62828'],
    ['bordô', '#6b1f2b'],
    ['cherry lacquer', '#771d30'],
    ['rosa velho', '#c88a95'],
    ['rosa orquídea', '#cf8db9'],
    ['rosa candy', '#f3a8c2'],
    ['fushia', '#d51f62'],
    ['fuchsia', '#d51f62'],
    ['magenta', '#c2185b'],
    ['salmão pastel', '#efa49a'],
    ['terracota', '#b85d42'],
    ['areia', '#d8c4a5'],
    ['castanho', '#7a4b2d'],
    ['mostarda', '#c89b2d'],
    ['créme brûlée', '#d7b27e'],
    ['creme brulee', '#d7b27e'],
    ['mousse', '#a88979'],
    ['lavanda', '#b9a4d7'],
    ['roxo', '#684198'],
    ['aqua', '#79d5d6'],
    ['azul ciano', '#00a7c4'],
    ['azul candy', '#8fc5ff'],
    ['azul pastel', '#aac9f5'],
    ['azul atol', '#20b7c9'],
    ['crystal blue', '#8bc8e6'],
    ['azul real', '#2457c5'],
    ['azul marinho', '#152a49'],
    ['azul eclipse', '#25324a'],
    ['limão', '#d8e84d'],
    ['verde lima', '#8fd400'],
    ['verde maçã', '#88bf43'],
    ['verde candy', '#a8dcb6'],
    ['cool matcha', '#a7b879'],
    ['verde jade', '#4cab87'],
    ['verde abadia', '#536b4b'],
    ['verde pastos', '#4e7a3c'],
    ['verde floresta', '#315c3b'],
    ['verde pantano', '#596249'],
    ['tropa', '#686b42'],
    ['dourado', '#c8a951'],
    ['ouro', '#c8a951'],
    ['prateado', '#b8bcc2'],
    ['prata', '#b8bcc2'],
    ['rosa-gold', '#b76e79'],
    ['rosa gold', '#b76e79'],
    ['branca', '#ffffff'],
    ['azul', '#4f83b8'],
    ['rosa', '#df8fa4'],
    ['verde', '#4f7f55']
  ]);

  const resolveColor = (value) => {
    const normalized = normalize(value);
    const exact = colors.get(normalized);
    if (exact) return exact;

    const baseName = normalized.split(/\s+aroma\s+/)[0].trim();
    return colors.get(baseName) || null;
  };

  const shirt = ({ x = 20, scale = 0.86, side = '', body = false, sleeves = false } = {}) => {
    const bodyZone = body ? '<rect class="if-print-zone-fill" x="30" y="28" width="20" height="27" rx="2" />' : '';
    const sleeveZones = sleeves
      ? '<path class="if-print-zone-fill" d="M9 17 24 10 27 22 16 29Z"/><path class="if-print-zone-fill" d="M56 10 71 17 64 29 53 22Z"/>'
      : '';
    const sideMark = side ? '<text class="if-print-zone-side" x="40" y="19" text-anchor="middle">' + side + '</text>' : '';

    return (
      '<g transform="translate(' + x + ' 1) scale(' + scale + ')">' +
      '<path class="if-print-zone-shirt" d="M25 8 34 3h12l9 5 18 9-8 14-9-5v41H24V26l-9 5-8-14 18-9Z"/>' +
      '<path class="if-print-zone-neck" d="M34 4c1 7 11 7 12 0"/>' +
      sleeveZones +
      bodyZone +
      sideMark +
      '</g>'
    );
  };

  const iconFor = (type) => {
    let drawing = '';
    if (type === 'front') drawing = shirt({ side: 'F', body: true });
    if (type === 'back') drawing = shirt({ side: 'V', body: true });
    if (type === 'sleeves') drawing = shirt({ sleeves: true });
    if (type === 'front-sleeves') drawing = shirt({ side: 'F', body: true, sleeves: true });
    if (type === 'back-sleeves') drawing = shirt({ side: 'V', body: true, sleeves: true });
    if (type === 'front-back') {
      drawing = shirt({ x: 0, scale: 0.64, side: 'F', body: true }) + shirt({ x: 59, scale: 0.64, side: 'V', body: true });
    }
    if (type === 'all') {
      drawing =
        shirt({ x: 0, scale: 0.64, side: 'F', body: true, sleeves: true }) +
        shirt({ x: 59, scale: 0.64, side: 'V', body: true, sleeves: true });
    }
    if (type === 'none') {
      drawing = shirt({}) + '<path class="if-print-zone-slash" d="M31 61 88 10"/>';
    }

    return '<span class="if-print-zone-icon" aria-hidden="true"><svg viewBox="0 0 120 72" focusable="false">' + drawing + '</svg></span>';
  };

  const decorate = (element, type) => {
    if (element.dataset.ifPrintZone) return;
    element.dataset.ifPrintZone = type;
    element.classList.add('if-print-zone-card');
    element.insertAdjacentHTML('afterbegin', iconFor(type));
  };

  const ensureSummary = (fieldset) => {
    let summary = fieldset.nextElementSibling;
    if (summary?.matches('[data-if-print-zone-selection]')) {
      summary.hidden = false;
      return summary;
    }

    summary = document.createElement('div');
    summary.className = 'if-print-zone-selection';
    summary.dataset.ifPrintZoneSelection = '';
    summary.setAttribute('aria-live', 'polite');
    summary.innerHTML =
      '<span class="if-print-zone-selection__prefix">Selecionado:</span>' +
      '<strong data-if-print-zone-name></strong>' +
      '<span class="if-print-zone-selection__separator" aria-hidden="true">—</span>' +
      '<strong class="if-print-zone-selection__price" data-if-print-zone-price></strong>' +
      '<span class="if-print-zone-selection__unit">por unidade</span>';
    fieldset.insertAdjacentElement('afterend', summary);
    return summary;
  };

  const updateSummary = (fieldset) => {
    const selected = fieldset.querySelector('input[data-option-name]:checked');
    if (!selected) return;

    const value = String(selected.value || selected.getAttribute('aria-label') || '').trim();
    let price = prices.get(normalize(value));

    if (selected.matches('[data-if-addon-print]')) {
      const selector = selected.closest('[data-if-addon-print-selector]');
      const basePrice = Number.parseInt(selector?.dataset.ifAddonBasePrice || '0', 10) || 0;
      const surcharge = Number.parseInt(selected.dataset.addonSurcharge || '0', 10) || 0;
      if (basePrice > 0) {
        price = formatMoney(basePrice + surcharge, selector?.dataset.ifAddonCurrency || 'EUR');
      }
    }

    if (!price) return;

    const summary = ensureSummary(fieldset);
    const nameElement = summary.querySelector('[data-if-print-zone-name]');
    const priceElement = summary.querySelector('[data-if-print-zone-price]');
    if (nameElement && nameElement.textContent !== value) nameElement.textContent = value;
    if (priceElement && priceElement.textContent !== price) priceElement.textContent = price;
  };

  const enforceAddonMode = () => {
    document.querySelectorAll('[data-if-addon-print-selector]').forEach((addonSelector) => {
      const scope = addonSelector.closest('.product-details') || document;
      const picker = scope.querySelector('variant-picker');
      if (!picker) return;

      picker.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
        const firstInput = fieldset.querySelector('input[data-option-name]');
        if (!firstInput || !isPrintOptionName(firstInput.dataset.optionName)) return;

        fieldset.hidden = true;
        fieldset.dataset.ifAddonNativePrintHidden = 'true';

        const existingSummary = fieldset.nextElementSibling;
        if (existingSummary?.matches('[data-if-print-zone-selection]')) {
          existingSummary.hidden = true;
        }

        const noPrint = Array.from(fieldset.querySelectorAll('input[data-option-name]')).find(
          (input) => normalize(input.value) === 'sem estampagem'
        );

        if (noPrint instanceof HTMLInputElement && !noPrint.checked && !fieldset.dataset.ifAddonResetting) {
          fieldset.dataset.ifAddonResetting = 'true';
          noPrint.click();
          requestAnimationFrame(() => {
            delete fieldset.dataset.ifAddonResetting;
          });
        }
      });
    });
  };

  const updateSummaries = () => {
    document.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
      const input = fieldset.querySelector('input[data-option-name]');
      if (!input || !isPrintOptionName(input.dataset.optionName)) return;
      if (fieldset.closest('variant-picker') && fieldset.closest('.product-details')?.querySelector('[data-if-addon-print-selector]')) {
        const existingSummary = fieldset.nextElementSibling;
        if (existingSummary?.matches('[data-if-print-zone-selection]')) existingSummary.hidden = true;
        return;
      }
      updateSummary(fieldset);
    });
  };

  const updatePersonalizationFields = () => {
    document.querySelectorAll('[data-if-clothing-personalization]').forEach((container) => {
      const scope = container.closest('.product-details') || document;
      let selectedPrint = null;

      const addonSelected = scope.querySelector('[data-if-addon-print]:checked');
      if (addonSelected instanceof HTMLInputElement) {
        selectedPrint = addonSelected;
      } else {
        scope.querySelectorAll('variant-picker fieldset.variant-option').forEach((fieldset) => {
          if (selectedPrint) return;
          const firstInput = fieldset.querySelector('input[data-option-name]');
          if (!firstInput || !isPrintOptionName(firstInput.dataset.optionName)) return;
          selectedPrint = fieldset.querySelector('input[data-option-name]:checked');
        });
      }

      const alwaysPersonalized = container.hasAttribute('data-if-personalization-always');
      const isPersonalized = alwaysPersonalized || Boolean(selectedPrint && normalize(selectedPrint.value) !== 'sem estampagem');
      const extra = container.querySelector('[data-if-personalization-extra]');

      if (extra) {
        extra.hidden = !isPersonalized;
        extra.querySelectorAll('[data-if-personalization-input]').forEach((field) => {
          field.disabled = !isPersonalized;
          // No layout têxtil, apenas o upload é obrigatório quando existe personalização.
          if (field instanceof HTMLInputElement && field.type === 'file') {
            field.required = isPersonalized;
          } else {
            field.required = false;
          }
        });
      }
    });
  };

  const updateColorSwatches = () => {
    document.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
      const firstInput = fieldset.querySelector('input[data-option-name]');
      if (!firstInput || !isColorOptionName(firstInput.dataset.optionName)) return;

      fieldset.classList.add('if-color-fieldset');

      const legend = fieldset.querySelector('legend');
      let selectedName = legend?.querySelector('[data-if-color-selected]');
      if (legend && !selectedName) {
        selectedName = document.createElement('span');
        selectedName.className = 'if-color-selected-name';
        selectedName.dataset.ifColorSelected = '';
        legend.appendChild(selectedName);
      }

      fieldset.querySelectorAll('label.variant-option__button-label').forEach((label) => {
        const input = label.querySelector('input[data-option-name]');
        if (!input) return;

        const name = String(input.value || input.getAttribute('aria-label') || '').trim();
        const color = resolveColor(name);
        if (!color) return;

        label.classList.add('if-color-swatch-card');
        label.style.setProperty('--if-color-swatch', color);
        label.title = name;
        label.setAttribute('aria-label', name);

        let dot = label.querySelector('.if-color-swatch-dot');
        if (!dot) {
          dot = document.createElement('span');
          dot.className = 'if-color-swatch-dot';
          dot.setAttribute('aria-hidden', 'true');
          label.insertBefore(dot, label.firstChild);
        }

        const text = label.querySelector('.variant-option__button-label__text');
        if (text) text.classList.add('if-color-swatch-text');
      });

      const selected = fieldset.querySelector('input[data-option-name]:checked');
      if (selectedName && selected) {
        selectedName.textContent = ' — ' + String(selected.value || '').trim();
      }
    });
  };

  const scan = () => {
    const root = document.querySelector('main') || document.body;
    if (!root) return;

    enforceAddonMode();

    document.querySelectorAll('[data-if-addon-print]').forEach((input) => {
      if (!(input instanceof HTMLInputElement) || input.dataset.ifAddonPriceBound) return;
      input.dataset.ifAddonPriceBound = 'true';
      input.addEventListener('change', () => {
        requestAnimationFrame(() => {
          updateSummaries();
          updatePersonalizationFields();
          updateAddonPriceDisplays();
        });
      });
    });

    const candidates = root.querySelectorAll('button, label, [role="radio"], [role="option"]');
    candidates.forEach((element) => {
      if (!(element instanceof HTMLElement) || element.dataset.ifPrintZone) return;
      const type = options.get(normalize(element.textContent));
      if (type) decorate(element, type);
    });

    updateSummaries();
    updatePersonalizationFields();
    updateColorSwatches();
    updateAddonPriceDisplays();
  };

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  document.addEventListener('shopify:product:select', (event) => {
    if (!(event.target instanceof Element) || !(event.promise instanceof Promise)) return;

    const section = event.target.closest('.shopify-section');
    const selector = section?.querySelector('[data-if-addon-print-selector]');
    if (!(selector instanceof HTMLElement)) return;

    event.promise
      .then((result) => {
        const rawPrice = Number(result?.variant?.price ?? result?.detail?.resource?.price);
        if (!Number.isFinite(rawPrice) || rawPrice <= 0) return;

        const priceInCents = rawPrice < 100 ? Math.round(rawPrice * 100) : Math.round(rawPrice);
        selector.dataset.ifAddonBasePrice = String(priceInCents);
        requestAnimationFrame(() => {
          updateSummaries();
          updateAddonPriceDisplays();
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[print-zone-options] Price update failed', error);
      });
  });

  const handleOptionInput = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.matches('[data-if-addon-print]')) {
      requestAnimationFrame(() => {
        updateSummaries();
        updatePersonalizationFields();
        updateAddonPriceDisplays();
      });
      return;
    }
    if (isPrintOptionName(target.dataset.optionName)) {
      requestAnimationFrame(() => {
        updateSummaries();
        updatePersonalizationFields();
      });
      return;
    }
    if (isColorOptionName(target.dataset.optionName)) {
      requestAnimationFrame(updateColorSwatches);
    }
  };

  // Some theme controls proxy radio interactions through their labels. Listen to
  // both events so the displayed total stays in sync in every product surface.
  document.addEventListener('change', handleOptionInput);
  document.addEventListener('input', handleOptionInput);
  document.addEventListener('click', handleOptionInput);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();

